import { render, staticRenderFns } from "./FormattedText.vue?vue&type=template&id=3e7cf1e0&scoped=true"
import script from "./FormattedText.vue?vue&type=script&lang=ts"
export * from "./FormattedText.vue?vue&type=script&lang=ts"
import style0 from "./FormattedText.vue?vue&type=style&index=0&id=3e7cf1e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7cf1e0",
  null
  
)

export default component.exports